import Cookies from './cookies';

const GA4 = {
    /**
     * Generates the relevant Segment event properties for
     * Google Analytics 4 Measurement Protocol Session.
     *
     * @return {Object}
     */
    properties: () => {
        let gaProperties = {};

        if (Cookies.get('_ga') !== '') {
            const client = Cookies.get('_ga').split('.')[2];
            const timestamp = Cookies.get('_ga').split('.')[3];

            if (client && timestamp) {
                gaProperties = {
                    ...gaProperties,
                    ga_client_id: `${client}.${timestamp}`,
                };
            }
        }

        if (Cookies.get('_ga_NFH1RDS99Q') !== '') {
            const sessionId = Cookies.get('_ga_NFH1RDS99Q').split('.')[2];

            if (sessionId) {
                gaProperties = {
                    ...gaProperties,
                    ga_session_id: sessionId,
                };
            }
        }

        return gaProperties;
    },

    /**
     * Generates the relevant Segment event options for
     * Google Analytics 4 Measurement Protocol Session.
     *
     * @return {Object}
     */
    options: () => {
        if (Cookies.get('_ga') === '') {
            return {};
        }

        const client = Cookies.get('_ga').split('.')[2];
        const timestamp = Cookies.get('_ga').split('.')[3];

        if (!client || !timestamp) {
            return {};
        }

        return {
            integrations: {
                'Google Analytics 4': {
                    clientId: `${client}.${timestamp}`,
                },
            },
        };
    },
};

export default GA4;



// WEBPACK FOOTER //
// ./src/lib/ga4.js